/* LB 25-10-2026: toques que no hacian nada (Clarity: "clics muertos").
   - Ficha: las estrellas de arriba (4,8/5) llevan a las reseñas.
   - Portadas con foto grande (inicio): al tocar la foto, los botones (Mujer / Hombre) laten para que se vea dónde tocar.
   - Colecciones: la foto de arriba baja a los productos. */
(function () {
  'use strict';
  function target() {
    return document.querySelector('.lb-review-wall, [id*="judgeme"], .jdgm-widget, #shopify-product-reviews');
  }
  function prep() {
    document.querySelectorAll('.lb-product-review-summary').forEach(function (el) {
      if (el.dataset.lbToque || !target()) return;
      el.dataset.lbToque = '1';
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Ver reseñas');
      el.style.cursor = 'pointer';
    });
  }
  function stars(ev) {
    var el = ev.target.closest && ev.target.closest('.lb-product-review-summary[data-lb-toque]');
    if (!el) return false;
    if (ev.type === 'keydown' && ev.key !== 'Enter' && ev.key !== ' ') return true;
    var t = target(); if (!t) return true;
    ev.preventDefault();
    var y = t.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({ top: y, behavior: 'smooth' });
    return true;
  }
  function banner(ev) {
    if (ev.type !== 'click' || !ev.target.closest) return;
    if (ev.target.closest('a,button,input,select,textarea,label')) return;
    var bn = ev.target.closest('.banner');
    if (!bn || !ev.target.closest('.banner__media')) return;
    var btns = bn.querySelectorAll('.banner__buttons a[href], .banner__box a.button[href]');
    if (!btns.length) return;
    if (btns.length === 1) { window.location.href = btns[0].href; return; }
    btns.forEach(function (b) {
      b.classList.remove('lb-toque-pulso'); void b.offsetWidth; b.classList.add('lb-toque-pulso');
      setTimeout(function () { b.classList.remove('lb-toque-pulso'); }, 900);
    });
  }
  function hero(ev) {
    if (ev.type !== 'click' || !ev.target.closest) return false;
    if (!ev.target.closest('.collection-hero__image-container') || ev.target.closest('a,button')) return false;
    var g = document.querySelector('#ProductGridContainer, #product-grid, .collection .grid');
    if (!g) return false;
    window.scrollTo({ top: g.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth' });
    return true;
  }
  function on(ev) { if (!stars(ev) && !hero(ev)) banner(ev); }
  var css = document.createElement('style');
  css.textContent = '@keyframes lbToquePulso{0%{transform:scale(1)}35%{transform:scale(1.08)}70%{transform:scale(.98)}100%{transform:scale(1)}}' +
    '.lb-toque-pulso{animation:lbToquePulso .8s ease}@media (prefers-reduced-motion:reduce){.lb-toque-pulso{animation:none;outline:2px solid currentColor;outline-offset:2px}}' +
    '.banner__media,.collection-hero__image-container{cursor:pointer}';
  document.head.appendChild(css);
  document.addEventListener('click', on);
  document.addEventListener('keydown', on);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prep); else prep();
  window.addEventListener('load', prep);
})();
